import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

/** The top bar slots that pages render their title and primary actions into. */
export const TopbarContext = createContext<{
  title: HTMLElement | null;
  actions: HTMLElement | null;
}>({ title: null, actions: null });

/**
 * Puts the page title and a one-line summary in the top bar, with optional actions beside it.
 * Outside the app shell (no top bar) it renders inline instead.
 */
export function PageHeader({
  title,
  lede,
  actions,
}: {
  title: ReactNode;
  lede?: ReactNode;
  actions?: ReactNode;
}) {
  const slots = useContext(TopbarContext);
  const heading = (
    <>
      <h1>{title}</h1>
      {lede && <p title={typeof lede === 'string' ? lede : undefined}>{lede}</p>}
    </>
  );

  if (!slots.title) {
    return (
      <>
        <h1 className="page-title">{title}</h1>
        {lede && <p className="page-lede">{lede}</p>}
        {actions && <div className="btn-row">{actions}</div>}
      </>
    );
  }

  return (
    <>
      {createPortal(heading, slots.title)}
      {actions && slots.actions && createPortal(actions, slots.actions)}
    </>
  );
}
